import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { baseUrl } from "../../libs/env";

const WarningAIGradingModel = ({
  isOpen,
  toggle,
  data,
  isWritingexercise,
  pagesOfCurrentSection,
  currentSection,
  setCurrentSection,
  currentSectionPage,
  setCurrentSectionPage,
  total_sections,
  FormSubmit,
}) => {
  // let showNextButton = true;
  // let currentNextSection = currentSection;
  // let currentNextSectionPage = currentSectionPage;
  // if (
  //   pagesOfCurrentSection === currentNextSectionPage &&
  //   currentSection !== total_sections
  // ) {
  //   currentNextSection = currentNextSection + 1;
  //   currentNextSectionPage = 0;
  // }

  // if (
  //   currentNextSection === total_sections &&
  //   pagesOfCurrentSection === currentNextSectionPage
  // ) {
  //   showNextButton = false;
  // }
  // const handleSubmission = () => {
  //   toggle();
  //   if (
  //     showNextButton &&
  //     data.assessment_flow !== assessmentFlow.SEQUENTIAL_EARLY_STOP
  //   ) {
  //     setCurrentSection(currentNextSection);
  //     setCurrentSectionPage(
  //       parseInt(`${currentNextSection}${currentNextSectionPage + 1}`)
  //     );
  //   } else {
  //     FormSubmit(DirectSubmission);
  //   }
  // };
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop="static"
      keyboard={false}
    >
      <ModalBody className="p-4">
        <div class="row align-items-center">
          <div class="col-10">
            <h3 class="text-purple text-start fs-5 fw-600">
              <svg
                className="me-1"
                width="22"
                height="22"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1685_1479)">
                  <path
                    d="M4.31258 21.0837V16.292M4.31258 6.70866V1.91699M1.91675 4.31283H6.70841M1.91675 18.6878H6.70841M12.4584 2.87533L10.7965 7.19632C10.5262 7.899 10.3911 8.25034 10.181 8.54587C9.99472 8.80779 9.76588 9.03663 9.50395 9.22288C9.20843 9.43301 8.85709 9.56814 8.15441 9.83841L3.83341 11.5003L8.15441 13.1622C8.85709 13.4325 9.20843 13.5676 9.50396 13.7778C9.76588 13.964 9.99472 14.1929 10.181 14.4548C10.3911 14.7503 10.5262 15.1017 10.7965 15.8043L12.4584 20.1253L14.1203 15.8043C14.3906 15.1017 14.5257 14.7503 14.7359 14.4548C14.9221 14.1929 15.151 13.964 15.4129 13.7778C15.7084 13.5676 16.0597 13.4325 16.7624 13.1622L21.0834 11.5003L16.7624 9.8384C16.0597 9.56814 15.7084 9.43301 15.4129 9.22288C15.151 9.03663 14.9221 8.80779 14.7359 8.54587C14.5257 8.25034 14.3906 7.899 14.1203 7.19632L12.4584 2.87533Z"
                    stroke="#563D64"
                    stroke-width="1.91667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1685_1479">
                    <rect width="23" height="23" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span>This is an </span>
              <strong>AI-Graded task</strong>
            </h3>
          </div>
          {/* <div class="col-2 text-end">
            <button
              onClick={() => {
                toggle();
              }}
              className="btn p-0 me-2 "
            >
              <img src={`${imageURl}/close.png`} width="17px" alt="Cross img" />
            </button>
          </div> */}
        </div>
        <div className="col-12">
          <p class="text-dark my-3 text-start">
            Show additional feedback generated by AI. This AI feedback is shown
            after students submit the task.
          </p>
          <div className="fst-italic mb-1">Example:</div>
          <div className="col-12">
            <div
              className={"d-flex rounded-5 p-1 px-2"}
              style={{ backgroundColor: "#f4f4f4" }}
            >
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 17 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_8457_8219)">
                    <path
                      d="M3.18783 15.5832V12.0415M3.18783 4.95817V1.4165M1.41699 3.18734H4.95866M1.41699 13.8123H4.95866M9.20866 2.12484L7.98028 5.31862C7.78052 5.83799 7.68065 6.09767 7.52533 6.31611C7.38767 6.5097 7.21852 6.67885 7.02493 6.8165C6.80649 6.97182 6.54681 7.0717 6.02744 7.27146L2.83366 8.49984L6.02744 9.72821C6.54681 9.92797 6.80649 10.0279 7.02493 10.1832C7.21852 10.3208 7.38767 10.49 7.52533 10.6836C7.68065 10.902 7.78052 11.1617 7.98028 11.6811L9.20866 14.8748L10.437 11.6811C10.6368 11.1617 10.7367 10.902 10.892 10.6836C11.0297 10.49 11.1988 10.3208 11.3924 10.1832C11.6108 10.0279 11.8705 9.92797 12.3899 9.72821L15.5837 8.49984L12.3899 7.27146C11.8705 7.0717 11.6108 6.97182 11.3924 6.8165C11.1988 6.67885 11.0296 6.5097 10.892 6.31611C10.7367 6.09767 10.6368 5.83799 10.437 5.31861L9.20866 2.12484Z"
                      stroke="#2E58D4"
                      stroke-width="1.41667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_8457_8219">
                      <rect width="17" height="17" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span className="px-2 fs-14">
                The correct answer is B. "Is given" is the passive form of
                "give," indicating that the subject of the sentence receives the
                action rather than performs it.
                <b className={"text-danger"}>Score: 0 points.</b>
              </span>
            </div>
            <div className="text-end mt-3">
              {data?.is_anonymous_user ? (
                <a
                  href={`${baseUrl}/logto_auth/signup/`}
                  className={"btn fw-bold py-1 rounded-5"}
                  style={{
                    borderColor: "rgba(103, 80, 114, 1)",
                    color: "#ffff",
                    backgroundColor: "rgba(103, 80, 114, 1)",
                  }}
                >
                  <span className="ps-1">Create a free account</span>
                </a>
              ) : (
                <>
                {data?.all_pages > 1 && (<button
                  type="button"
                  onClick={() => {
                    toggle();
                  }}
                  className="btn fw-bold py-1 rounded-5 me-2 px-4"
                  style={{
                    borderColor: "#000000",
                    color: "#563D64",
                    backgroundColor: "#F0F5FC",
                  }}
                >
                  <span>Continue without</span>
                </button>)}
                <a
                  href={`${baseUrl}/user/manage-credits`}
                  className={"btn fw-bold py-1 rounded-5"}
                  style={{
                    borderColor: "rgba(103, 80, 114, 1)",
                    color: "#ffff",
                    backgroundColor: "rgba(103, 80, 114, 1)",
                  }}
                >
                  <span className="ps-1">Manage credits</span>
                </a>
                </>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

WarningAIGradingModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

WarningAIGradingModel.defaultProps = { isOpen: false };

export default WarningAIGradingModel;
